import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-commande-client',
  templateUrl: './document-commande-client.component.html',
  styleUrls: ['./document-commande-client.component.scss']
})
export class DocumentCommandeClientComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
